'use client';

import Container from '@components/Container/Container';
import Packs from '@components/Marketing/Packs';
import Pricing from '@components/Model/Pricing/Pricing';
import Examples from '@components/Marketing/Cards/Examples';
import PhotoGallery from '@components/Marketing/PhotoGallery';
import FAQ from '@components/FAQ/FAQ';
import Usecases from '@components/Marketing/Usecases';
import Quality from '@components/Marketing/Quality';
import OneTapComponent from '@components/OneTap/OneTapComponent';
import ProHeadshotsNoPhotographer from '@components/Marketing/Heroes/pro-headshots-no-photographer';
import AffiliateProgramCard from '@components/Cards/AffiliateProgramCard';
import BrowsePhotoPacksCard from '@components/Cards/BrowsePhotoPacksCard';
import ComparisonTable from '@components/Marketing/comparison-table';
import dynamic from 'next/dynamic';
import ClothingAndLocations from '@components/Marketing/Sections/clothing-and-locations';
import { cn } from '@/lib/utils';
import { ScrollTriggeredDiscountDialogExperiment } from '@components/Marketing/ScrollTriggeredDiscountDialog';
import StatsigReadyGuardPolling from '@components/StatsigReadyGuard';

const HowItWorks = dynamic(() => import('@components/Marketing/HowItWorks'), { ssr: false });

export function MarketingClient() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <ProHeadshotsNoPhotographer />

      {/* Use the wrapper component to handle discount dialog logic */}
      <StatsigReadyGuardPolling>
        <ScrollTriggeredDiscountDialogExperiment
          discountCode="PICSTUDIO10"
          discountPercentage={10}
          // Optional: Adjust scroll offset if needed
          // scrollTriggerOffset={600}
        />
      </StatsigReadyGuardPolling>

      <main className="relative">
        <Container className={cn('max-w-screen-2xl space-y-16 py-8 md:py-16')}>
          <div className="relative">
            <div className="flex flex-col gap-16">
              <HowItWorks />

              <section className="relative">
                <Packs className="mt-0" />
              </section>

              <section className="w-full bg-muted/50 rounded-lg p-8">
                <PhotoGallery />
              </section>

              <section className="relative">
                <ClothingAndLocations />
              </section>

              <div className="space-y-16">
                <section className="relative">
                  <Usecases />
                </section>
                <section className="relative">
                  <Quality />
                </section>
              </div>

              <section className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
                <BrowsePhotoPacksCard />
                <Examples />
                <AffiliateProgramCard />
              </section>

              <section className="relative">
                <ComparisonTable />
              </section>

              <section id="pricing" className="scroll-mt-16 md:bg-card md:p-8 rounded-lg">
                <Pricing />
              </section>

              <section className="relative">
                <FAQ variant="collapsible" />
              </section>
            </div>
          </div>
        </Container>
      </main>

      <OneTapComponent />
    </div>
  );
}
